import { render, staticRenderFns } from "./descriptionPopup.vue?vue&type=template&id=bcf47eda&scoped=true&"
import script from "./descriptionPopup.vue?vue&type=script&lang=js&"
export * from "./descriptionPopup.vue?vue&type=script&lang=js&"
import style0 from "./descriptionPopup.vue?vue&type=style&index=0&id=bcf47eda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf47eda",
  null
  
)

export default component.exports